import { Component, OnInit, Inject } from "@angular/core";
import { Supplier } from "../models/supplier";
import { AdminService } from "../services/admin.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FailModuleComponent } from "../fail-module/fail-module.component";
import { DeleteDialogComponent } from "../delete-dialog/delete-dialog.component";
import { CryptographyService } from "../services/cryptography.service";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { UserRoleEnum } from "../core/constant";
import { OwlOptions } from "ngx-owl-carousel-o";

@Component({
  selector: "app-national-supplier-detail-view",
  templateUrl: "./national-supplier-detail-view.component.html",
  styleUrls: ["./national-supplier-detail-view.component.scss"],
})
export class NationalSupplierDetailViewComponent implements OnInit {
  error: string = "";
  loading: boolean = false;
  supplier: Supplier = new Supplier();
  userRole: number;
  equipmentExpanded: boolean = true;

  toggleEquipment() {
    this.equipmentExpanded = !this.equipmentExpanded;
  }

  get userRoleEnum() {
    return UserRoleEnum;
  }

  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    margin: 16,
    navText: ['<i class="material-icons">chevron_left</i>', '<i class="material-icons">chevron_right</i>'],
    responsive: {
      0: {
        items: 1
      },
      576: {
        items: 2
      },
      768: {
        items: 3
      },
      1100: {
        items: 4
      },
      1400: {
        items: 5
      }
    },
    nav: true
  };

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private adminService: AdminService,
    private ngbModal: NgbModal,
    private cryptographyService: CryptographyService,
    @Inject(LOCAL_STORAGE)
    private storage: WebStorageService
  ) {
    this.supplier.id = parseInt(
      this.activeRoute.snapshot.paramMap.get("supplierId")
    );
    this.userRole = this.cryptographyService.decryptData(
      this.storage.get("userRole")
    );
  }

  ngOnInit() {
    if (this.supplier.id) {
      this.getSupplierBySupplierId(this.supplier.id);
    }
  }

  getSupplierBySupplierId(supplierId: number) {
    this.loading = true;
    this.adminService
      .GetSupplierDetailsById(supplierId)
      .subscribe(
        (data: any) => {
          this.supplier = new Supplier(data);
          this.loading = false;
        },
        (error: string) => {
          this.error = error;
          const modalRef = this.ngbModal.open(FailModuleComponent);
          modalRef.componentInstance.errorMessage = error;
          this.loading = false;
        }
      );
  }

  goBack() {
    this.router.navigate(["/view-all-national-supplier-list"]);
  }

  onEdit() {
    this.router.navigate(["/add-national-supplier/" + this.supplier.id]);
  }

  openDeleteModal() {
    const modalRef = this.ngbModal.open(DeleteDialogComponent);
    modalRef.componentInstance.title = "Do you want to remove this supplier from the list?";
    modalRef.componentInstance.message = "All the dependencies will be removed along with this Supplier";
    modalRef.componentInstance.deleteItem = this.supplier;

    modalRef.componentInstance.deletePopupEmit.subscribe((deleteItem) => {
      if (deleteItem != null) {
        this.loading = true;
        this.adminService.DeleteSupplier(this.supplier).subscribe(
          () => {
            this.loading = false;
            this.router.navigate(["/view-all-national-supplier-list"]);
          },
          () => {
            this.loading = false;
          }
        );
      }
      this.ngbModal.dismissAll();
    });
  }

  viewEquipmentDetail(item: any) {
    if (item.standardId) {
      this.router.navigate(["/view-all-national-equipment-standard-detail-view/" + item.standardId]);
    }
  }

  getFormattedMarkets(): string {
    if (!this.supplier.assignedMarkets || this.supplier.assignedMarkets.length === 0) {
      return "None assigned";
    }
    if (this.supplier.assignedMarkets.length === 1) {
      return this.supplier.assignedMarkets[0] + ".";
    }
    const last = this.supplier.assignedMarkets[this.supplier.assignedMarkets.length - 1];
    const rest = this.supplier.assignedMarkets.slice(0, -1).join(", ");
    return `${rest} & ${last}.`;
  }
}
